module.exports = __webpack_public_path__ + "01_long_black.b453e1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_long_black.png
// module id = EhYU
// module chunks = 0